export default __webpack_public_path__ + "static/media/portadaMrBills.13c0f960.png";